export interface NewClaManager {
  firstName: string;
  lastName: string;
  email: string;
  projectId: string;
  companyId: string;
  claGroupId: string;
}
